import React from 'react';

const ErrorPage = () => {
  return (
    <div>
      <div className="Content-Wrap">
        <div className="Main-Content">
          <h1 className="App-Subtitle">Page Not Found</h1>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
